import React from 'react'

const ThankYou = () => {
    return (
        <>
            <div className="d-flex justify-content-center align-items-center full-height-background">
                <div className="container justify-content-center align-items-center">
                    <div className="bg-white min-h-custom col-12 col-sm-8 mx-auto d-flex align-items-center justify-content-center">
                        <div className="p-4 d-flex justify-content-center align-items-center flex-column">
                            <div className="mb-3 d-flex justify-content-center align-items-center checkicon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M20 6L9 17l-5-5"></path>
                                </svg>
                            </div>
                            <h1 className="mb-3">Thank You!</h1>
                            <p className="text-center mb-0">All questions have been attempted.</p>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default ThankYou;